import { GetCurrentUserToken } from '@/lib/db/auth';

const path = ( a, queryOptions = null ) => {
  const query = ( () => {
    if ( !queryOptions ) {
      return '';
    }

    const queryKeys   = Object.keys( queryOptions );
    const queryString = queryKeys
      .map( key => `${key}=${encodeURIComponent( queryOptions[key] )}` )
      .join( '&' );

    return `?${queryString}`;
  } )();

  return `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}/api/${a}${query}`;
};

// simply uses a try/catch block to
// ensure standard behaviors on
// fetch
const fetchPromise = ( route, options ) => new Promise( ( resolve, reject ) => {
  try {
    // console.log( 'fetching route', route );
    fetch( route, options )
      .then( async ( res ) => {
        const status = parseInt( res.status, 10 );

        if ( ( Math.floor( status / 100 ) * 100 ) !== 200 ) {
          reject( res );

          return;
        }

        const body = await _body( res );
        resolve( body, res );
      } );
  }
  catch ( e ) {
    reject( e );
  }
} );

const _body = async ( res ) => {
  const text = await res.text();

  const firstChar = text.charAt( 0 );
  const isJson    = ( firstChar === '{' || firstChar === '[' );

  if ( isJson ) {
    return JSON.parse( text );
  }

  return text;
};

//! Not called, Not Needed, Marked for Deletion!
/*
// export const Upload = authenticate( _auth => fetchPromise( path( 'sheets/upload' ), {
// 	method  : 'POST',
// 	headers : _auth.defaultHeaders
// } ) );
*/

export const Upload = async ( csv ) => {
  const token = await GetCurrentUserToken();
  const res = await fetch( path( 'sheet-upload/csv' ), {
    method  : 'POST',
    headers : new Headers( {
      'Content-Type'  : 'text/csv',
      'Authorization' : `Bearer ${token}`
    } ),
    body : csv
  } );
  // console.log( 'got response', res );
  if ( res.status !== 200 ) throw res;
  return res;
};

export const Search = query => fetchPromise( path( 'catalog/search', { searchQuery : query } ), {
  method  : 'GET',
  headers : new Headers( {
    'Content-Type' : 'application/json',
  } ),
} );

export const SendFeedback = async ( feedback ) => {
  const token = await GetCurrentUserToken();
  const res = await fetch( path( 'give-feedback' ), {
    method  : 'POST',
    headers : new Headers( {
      'Authorization' : `Bearer ${token}`,
      'Content-Type'  : 'application/json',
    } ),
    body : JSON.stringify( feedback )
  } );
  if ( res.status !== 200 ) throw new Error( res );
  return res;
};


export const PrintPlan = async () => {
  const token = await GetCurrentUserToken();
  const res = await fetch( path( 'your-plan/print' ), {
    method  : 'POST',
    headers : new Headers( {
      'Authorization' : `Bearer ${token}`,
      'Accept'        : 'application/pdf'
    } )
  } );
  if ( res.status !== 200 ) throw new Error( 'Unable to download Your Plan' );
  return res;
};
